import apiClient from '@/lib/api/apiClient'
import { extractErrorMessage } from '@/lib/utils/errorHandling'
import type {
  DashboardTile,
  DashboardTileListParams,
  DashboardTileSubmitPayload,
} from '../types'

const BASE = '/api/dashboard_tiles'

export async function getDashboardTiles(
  params: DashboardTileListParams = {},
): Promise<DashboardTile[]> {
  try {
    const response = await apiClient.get<DashboardTile[]>(BASE, { params })
    return response.data ?? []
  } catch (error) {
    throw new Error(extractErrorMessage(error) || 'Failed to load dashboard tiles')
  }
}

export async function saveDashboardTile(
  payload: DashboardTileSubmitPayload,
  tileId?: number,
): Promise<DashboardTile> {
  try {
    const url = tileId ? `${BASE}/${tileId}` : BASE
    const response = await apiClient.post<DashboardTile>(url, payload)
    return response.data
  } catch (error) {
    throw new Error(extractErrorMessage(error) || 'Failed to save dashboard tile')
  }
}

export async function deleteDashboardTile(tileId: number): Promise<void> {
  try {
    await apiClient.delete(`${BASE}/${tileId}`)
  } catch (error) {
    throw new Error(extractErrorMessage(error) || 'Failed to delete dashboard tile')
  }
}

export async function reorderDashboardTiles(tiles: DashboardTile[]): Promise<void> {
  try {
    await apiClient.post(`${BASE}/reorder`, tiles)
  } catch (error) {
    throw new Error(extractErrorMessage(error) || 'Failed to reorder tiles')
  }
}
